import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const QuarterTimerIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-quarterTimer"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M34,8 C40.075,8 45,12.925 45,19 L34,19 L34,8 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M34,4 C25.7157153,4 19,10.7157153 19,19 C19,27.2842847 25.7157153,34 34,34 C42.2842847,34 49,27.2842847 49,19 C49,10.7157153 42.2842847,4 34,4 Z M34,6 C41.1797153,6 47,11.8202847 47,19 C47,26.1797153 41.1797153,32 34,32 C26.8202847,32 21,26.1797153 21,19 C21,11.8202847 26.8202847,6 34,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M37,0 L31,0 C30.448,0 30,0.448 30,1 C30,1.552 30.448,2 31,2 L37,2 C37.552,2 38,1.552 38,1 C38,0.448 37.552,0 37,0"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon fill="#00000" className={styles.defaultColor} points="33 5 35 5 35 0 33 0" />
        <path
          d="M44.2928932 5.29289322C44.6834175 4.90236893 45.3165825 4.90236893 45.7071068 5.29289322 46.0675907 5.65337718 46.0953203 6.22060824 45.7902954 6.61289944L45.7071068 6.70710678 43.7071068 8.70710678C43.3165825 9.09763107 42.6834175 9.09763107 42.2928932 8.70710678 41.9324093 8.34662282 41.9046797 7.77939176 42.2097046 7.38710056L42.2928932 7.29289322 44.2928932 5.29289322ZM22.2928932 5.29289322C22.6533772 4.93240926 23.2206082 4.90467972 23.6128994 5.20970461L23.7071068 5.29289322 25.7071068 7.29289322C26.0976311 7.68341751 26.0976311 8.31658249 25.7071068 8.70710678 25.3466228 9.06759074 24.7793918 9.09532028 24.3871006 8.79029539L24.2928932 8.70710678 22.2928932 6.70710678C21.9023689 6.31658249 21.9023689 5.68341751 22.2928932 5.29289322Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
